module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Md.f0890b6.ttf";